import styled from '@emotion/styled';
import Modal from '@components/Modal';
import Button from '@components/Button';
import STRINGS from '@utils/strings';

const Title = styled.div(({ theme }) => ({
    ...theme.typography.h6,
    marginBottom: theme.spacing.m,
    display: 'flex',
    justifyContent: 'center'
}));

const ButtonContainer = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-evenly',
    gap: 16,
    flexDirection: 'column',
    [theme.mediaQuery.desktopUp]: {
        flexDirection: 'row'
    }
}));

function ConfirmationModal({ children, show, customButtonLabel, onClickCustomButton, onConfirm, onClose, title, confirmationButtonLabel=STRINGS.confirm, cancelButtonLabel=STRINGS.cancel, style, ...otherProps }) {
    return (<>
        <Modal show={show} onClose={onClose}>
            <Title>{title}</Title>
            {children}
            <ButtonContainer>
                <Button onClick={onConfirm}>{confirmationButtonLabel}</Button>
                {customButtonLabel ? <Button onClick={onClickCustomButton}>{customButtonLabel}</Button> : null}
                <Button secondary onClick={onClose}>{cancelButtonLabel}</Button>
            </ButtonContainer>
        </Modal>
    </>);
}

export default ConfirmationModal;
